import { render, staticRenderFns } from "./SuggestionEdit.vue?vue&type=template&id=17fc821e"
import script from "./SuggestionEdit.vue?vue&type=script&lang=js"
export * from "./SuggestionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports